// MAIN_TITLE
import en from './en'
import ru from './ru'
import errors from './errors'

// Modules
import pdd from '@/modules/pdd/config/locale'
import gis from '@/modules/gis/config/locale'
import info from '@/modules/info/config/locale'
import user from '@/modules/user/config/locale'
import mrir from '@/modules/mrir/config/locale'
import about from '@/modules/about/config/locale'
import ksodd from '@/modules/ksodd/config/locale'
import asudd from '@/modules/asudd/config/locale'
import tsodd from '@/modules/tsodd/config/locale'
import feedback from '@/modules/feedback/config/locale'
import tsoddSecondary from '@/modules/tsodd-secondary/config/locale'
import complexTable from '~/complex-table/config/locale'
import filesComments from '~/files-comments/config/locale'
import layerOptions from '~/layer-options/config/locale'
import accessModal from '~/access-modal/config/locale'
import reports from '@/modules/reports/config/locale'
import its from '@/modules/its-control/config/locale'
import parking from '@/modules/parking/config/locale'
import modeling from '@/modules/modeling/config/locale'
import notification from '@/extensions/notification/locale'
import scenario from '@/modules/scenario/config/locale'
import licenses from '@/modules/licenses/config/locale'
import explorer from '@/modules/explorer/config/locale'
import emergency from '@/modules/emergency/config/locale'
import roadWorks from '@/modules/road-works/config/locale'
import regulations from '@/modules/regulations/config/locale'
import monitoringPt from '@/modules/monitoring-pt/config/locale'
import enumRegistry from '@/modules/enum-registry/config/locale'
import transportSituation from '@/modules/transport-situation/config/locale'
import attributesManager from '@/modules/attributes-manager/config/locale'
import settings from '@/modules/settings/config/locale'
import sourceAccess from '@/modules/source-access/config/locale'
import exportRegistry from '@/modules/export-registry/config/locale.json'
import components from './components.json'

// Components
import drawPanel from '@/components/draw-panel/config/locale'
import mapHelpers from '@/components/map-helpers/configs/locale'
import tips from '@/components/tips/locale'

export default {
  ru: Object.assign(
    ru,
    its.ru,
    gis.ru,
    pdd.ru,
    mrir.ru,
    user.ru,
    info.ru,
    asudd.ru,
    about.ru,
    ksodd.ru,
    tsodd.ru,
    errors.ru,
    parking.ru,
    settings.ru,
    reports.ru,
    modeling.ru,
    explorer.ru,
    licenses.ru,
    scenario.ru,
    emergency.ru,
    drawPanel.ru,
    roadWorks.ru,
    regulations.ru,
    complexTable.ru,
    filesComments.ru,
    layerOptions.ru,
    accessModal.ru,
    components.ru,
    notification.ru,
    enumRegistry.ru,
    monitoringPt.ru,
    tsoddSecondary.ru,
    transportSituation.ru,
    transportSituation.ru,
    attributesManager.ru,
    mapHelpers.ru,
    tips.ru,
    exportRegistry.ru,
    sourceAccess.ru,
    feedback.ru
  ),
  en: Object.assign(
    en,
    gis.en,
    pdd.en,
    its.en,
    user.en,
    mrir.en,
    info.en,
    about.en,
    ksodd.en,
    asudd.en,
    tsodd.en,
    errors.en,
    parking.en,
    reports.en,
    modeling.en,
    settings.en,
    explorer.en,
    licenses.en,
    scenario.en,
    drawPanel.en,
    roadWorks.en,
    components.en,
    emergency.en,
    complexTable.en,
    filesComments.en,
    layerOptions.en,
    accessModal.en,
    regulations.en,
    notification.en,
    enumRegistry.en,
    monitoringPt.en,
    tsoddSecondary.en,
    transportSituation.en,
    transportSituation.en,
    attributesManager.en,
    mapHelpers.en,
    tips.en,
    exportRegistry.en,
    sourceAccess.en,
    feedback.en
  )
}
